const createReducer = (intialState, handlers) => (state = intialState, action) =>
  Object.prototype.hasOwnProperty.call(handlers, action.type)
    ? handlers[action.type](state, action)
    : state;

export default createReducer;
